export default __webpack_public_path__ + "static/media/eth.a85b6de0.png";